/**
 * Bundle Preloader
 *
 * Preloads admin bundle when user starts interacting with login form
 * This makes the post-login experience instant
 */

let adminBundlePreloaded = false;
let preloadPromise = null;

/**
 * Preload the admin bundle in the background
 * Safe to call multiple times - will only preload once
 */
export const preloadAdminBundle = () => {
  // Only preload once
  if (adminBundlePreloaded || preloadPromise) {
    return preloadPromise;
  }

  console.log('🚀 Preloading admin bundle...');

  // Create preload promises for all critical admin components
  preloadPromise = Promise.all([
    // Admin container (lazy loaded via routes)
    import(/* webpackChunkName: "admin-preload" */ '../containers/Admin/index.es6'),

    // Drawer components (Header, Sidebar, loaded inside Admin)
    import(/* webpackChunkName: "drawer-preload" */ '../components/Drawer/DrawerNew'),

    // Note: Main is already loaded eagerly as the route wrapper, no need to preload
  ])
    .then(() => {
      console.log('✅ Admin bundle preloaded successfully');
      adminBundlePreloaded = true;
    })
    .catch((error) => {
      console.warn('⚠️ Admin bundle preload failed (non-critical):', error);
      // Reset so it can be retried
      preloadPromise = null;
    });

  return preloadPromise;
};

/**
 * Reset preload state (useful for testing or logout)
 */
export const resetPreloadState = () => {
  adminBundlePreloaded = false;
  preloadPromise = null;
};

/**
 * Check if admin bundle is already preloaded
 */
export const isAdminBundlePreloaded = () => {
  return adminBundlePreloaded;
};
